import { render, staticRenderFns } from "./SummaryMobile.vue?vue&type=template&id=496da4fb&scoped=true"
import script from "./SummaryMobile.vue?vue&type=script&lang=ts"
export * from "./SummaryMobile.vue?vue&type=script&lang=ts"
import style0 from "./SummaryMobile.vue?vue&type=style&index=0&id=496da4fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496da4fb",
  null
  
)

export default component.exports